// Error handling after a failed form submit (Redmine #19780). EXT:form
// validates on the server, so the page reloads with the errors; a live
// region (role="alert") is not announced on page load. Instead the focus
// moves onto the error summary at the top of the form (Fluid override
// Templates/Form.fluid.html, data-th-form-errors): screen readers read
// its heading and the list of errors right away, and every entry links
// to its field. Without a summary the first invalid field gets the
// focus, its aria-describedby points at the error message.
// The summary links move the focus into the field itself, a plain
// fragment jump would only scroll there in some browsers.
function initFormErrors(): void {
  document.querySelectorAll<HTMLFormElement>('form').forEach((form) => {
    const summary = form.querySelector<HTMLElement>('[data-th-form-errors]');
    summary?.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const field = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (field) {
          event.preventDefault();
          field.focus();
        }
      });
    });

    const target = summary ?? form.querySelector<HTMLElement>('[aria-invalid="true"]');
    if (target) {
      focusAfterLoad(target);
    }
  });
}

// The form posts to a URL with a fragment (#<form id>); the browser jumps
// to it after the load event and resets the focus to the body, so the
// focus is set once that jump is done.
function focusAfterLoad(target: HTMLElement): void {
  const focus = (): void => {
    requestAnimationFrame(() => target.focus());
  };
  document.readyState === 'complete' ? focus() : window.addEventListener('load', focus, { once: true });
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initFormErrors) : initFormErrors();
